import { render } from "./NotificacoesIndex.vue?vue&type=template&id=00b29151&scoped=true&ts=true"
import script from "./NotificacoesIndex.vue?vue&type=script&lang=ts"
export * from "./NotificacoesIndex.vue?vue&type=script&lang=ts"

import "./NotificacoesIndex.vue?vue&type=style&index=0&id=00b29151&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b29151"]])

export default __exports__